import {Component, DestroyRef, HostListener} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
    faAngleLeft,
    faAngleRight,
    faArrowDown,
    faArrowUp,
    faCar,
    faCheck,
    faCircleXmark,
    faFileExcel,
    faMagnifyingGlass,
    faPen,
    faPenToSquare,
    faSquarePlus,
    faTrash,
    faUpload
} from '@fortawesome/free-solid-svg-icons';
import {ApiService} from '../../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {getFileNameFromResponse} from '../../../common/utils';
import saveAs from 'file-saver';
import {GenericSearchComponent} from '../../shared/search-suggestion/search-suggestion.component';
import {VehicleNumberCopyDirective} from '../../shared/vehicle-number-copy/vehicle-number-copy.directive';
import {BulkImportResultComponent} from '../../shared/bulk-import-result/bulk-import-result.component';
import {handleBulkImportFallbackError} from '../../shared/bulk-import-result/bulk-import-result.utils';
import {BulkUploadFlow} from '../../shared/bulk-upload-flow/bulk-upload-flow';
import {HOTLIST_BULK_UPLOAD_SHELL} from '../../shared/bulk-upload-flow/bulk-upload-shell.configs';
import {BulkUploadShellComponent} from '../../shared/bulk-upload-shell/bulk-upload-shell.component';
import {SharedTableToolbarComponent} from '../../shared/table-toolbar/shared-table-toolbar.component';
import {
    BulkDeleteImpactItem,
    BulkDeletePreviewShellComponent,
} from '../../shared/bulk-delete-preview-shell/bulk-delete-preview-shell.component';
import {
    buildDeletePayload,
    BulkSelectionState,
    clearSelection,
    createEmptySelection,
    hasSelection,
    isKeySelected,
    isPageFullySelected,
    selectAllMatching,
    selectedCount,
    selectVisiblePage,
    SharedBulkSelectionBannerComponent,
    toggleKey,
} from '../../shared/bulk-selection';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../../shared/constants/pagination.constants';
import {encodeSortColumnParam, toggleColumnSort} from '../../shared/utils/table-sort.utils';
import {ReportingDatePipe} from '../../shared/datetime/reporting-date.pipe';
import {RoleService} from '../../services/role.service';
import {AuthService} from '../../services/auth.service';
import {VtePaginationComponent} from '../../shared/vte/vte-pagination/vte-pagination.component';

@Component({
    selector: 'app-hot-listed-vehicle',
    imports: [ReportingDatePipe, CommonModule, FormsModule, FontAwesomeModule, GenericSearchComponent, VehicleNumberCopyDirective, BulkImportResultComponent, BulkUploadShellComponent, SharedTableToolbarComponent, SharedBulkSelectionBannerComponent, BulkDeletePreviewShellComponent, VtePaginationComponent],
    templateUrl: './hot-listed-vehicle.component.html',
    styleUrl: './hot-listed-vehicle.component.css'
})
export class HotListedVehicleComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  
  searchText: string | null = '';
  recordsPerPage: number = 10;
  currentPage: number = 1;
  hotlistedVehicles:any = []; 
  nextPage: number | null = null;
  previousPage: number | null = null;
  limit: number = 10;
  showConfirmationDialog: boolean = false;
  pId: number = 0;
  totalRecords:number = 0;
  showReason: Boolean = false;
  reason: string = '';
  role: string = ''
  todayDate: Date = new Date();
  hoverRowId: number | null = null;
    sortColumn = '';
    sortDirection: 'asc' | 'desc' | '' = '';
    hoveredColumn = '';
    bulkSelection: BulkSelectionState<number> = createEmptySelection();
    showBulkDeleteDialog = false;
    bulkDeletePreview: any = null;
    bulkDeleting = false;
    bulkDeleteWillDelete: BulkDeleteImpactItem[] = [];
    bulkDeleteRetained: BulkDeleteImpactItem[] = [];

    readonly bulkUploadShell = HOTLIST_BULK_UPLOAD_SHELL;
    readonly bulkUpload: BulkUploadFlow;

  constructor(private apiService: ApiService,
    library: FaIconLibrary,
    private router: Router,
              private toastr: ToastrService,
              private roleService: RoleService,
              private authService: AuthService,
              private destroyRef: DestroyRef,
    ) {
      this.bulkUpload = new BulkUploadFlow(this.toastr, {
          failureFilename: 'hotlist_bulk_upload_failures.csv',
          defaultSuccessMessage: 'Hotlist records uploaded successfully.',
          upload: (formData) => this.apiService.bulkUploadHotlist(formData),
      }, this.destroyRef);
    this.fetchData(this.currentPage, this.recordsPerPage);
    library.addIcons(faTrash,
                    faFileExcel,
                    faAngleRight,
                    faAngleLeft,
                    faUpload,
                    faSquarePlus,
                    faMagnifyingGlass,
                    faPen,
                    faPenToSquare,
                    faCar,
                    faCheck,
                    faCircleXmark,
        faArrowUp,
        faArrowDown,
                  );
    
    let user = localStorage.getItem('user');
    if (user){
      const userObj = JSON.parse(user)
      this.role = userObj['groups']
    }
    
  }

    get canBulkDelete(): boolean {
        const userInfo = this.authService.getCurrentUserInfo?.() ?? null;
        const groups = Array.isArray(userInfo?.role) ? userInfo.role : [userInfo?.role].filter(Boolean);
        return this.roleService.isPlatformSuperuser() || this.roleService.isAdmin(groups);
    }

    get visiblePageIds(): number[] {
        return (this.hotlistedVehicles || [])
            .map((row: any) => row?.id)
            .filter((id: unknown): id is number => id != null);
    }

    get bulkSelectedCount(): number {
        return selectedCount(this.bulkSelection);
    }

    get hasBulkSelection(): boolean {
        return hasSelection(this.bulkSelection);
    }

    get allVisibleSelected(): boolean {
        return isPageFullySelected(this.bulkSelection, this.visiblePageIds);
    }

    isSelected(id: number): boolean {
        return isKeySelected(this.bulkSelection, id);
    }

    toggleSelection(id: number, checked: boolean): void {
        this.bulkSelection = toggleKey(this.bulkSelection, id, checked);
    }

    toggleSelectAll(checked: boolean): void {
        this.bulkSelection = selectVisiblePage(this.bulkSelection, this.visiblePageIds, checked);
    }

    onSelectAllMatching(): void {
        this.bulkSelection = selectAllMatching(this.bulkSelection, this.totalRecords);
    }

    onClearBulkSelection(): void {
        this.bulkSelection = clearSelection();
    }

    private buildBulkDeletePayload(): Record<string, unknown> {
        return buildDeletePayload(this.bulkSelection, {
            idField: 'ids',
            filters: {search: this.searchText || ''},
        });
    }

    openBulkDeletePreview(): void {
        if (!this.canBulkDelete || !this.hasBulkSelection) {
            return;
        }
        this.apiService.previewHotlistBulkDelete(this.buildBulkDeletePayload()).subscribe({
            next: (preview: any) => {
                this.bulkDeletePreview = preview;
                this.bulkDeleteWillDelete = [
                    {label: 'Hotlist entries', count: preview?.will_delete?.hotlist_entries || 0},
                ];
                this.bulkDeleteRetained = [
                    {label: 'Vehicle database', count: preview?.related_retained?.vehicles || 0},
                    {label: 'Monitoring rules', count: preview?.related_retained?.monitoring_rules || 0},
                    {label: 'Blacklist entries', count: preview?.related_retained?.blacklisted || 0},
                    {label: 'Vehicle logs', count: preview?.related_retained?.vehicle_logs || 0},
                    {label: 'Alert logs', count: preview?.related_retained?.alert_logs || 0},
                ];
                this.showBulkDeleteDialog = true;
            },
            error: (err) => {
                this.toastr.error(err?.error?.detail || 'Unable to analyze delete impact.', 'Error');
            },
        });
    }

    closeBulkDeleteDialog(): void {
        if (this.bulkDeleting) {
            return;
        }
        this.showBulkDeleteDialog = false;
        this.bulkDeletePreview = null;
    }

    confirmBulkDelete(): void {
        if (!this.canBulkDelete || !this.hasBulkSelection || this.bulkDeleting) {
            return;
        }
        this.bulkDeleting = true;
        this.apiService.bulkDeleteHotlist(this.buildBulkDeletePayload()).subscribe({
            next: (result: any) => {
                this.bulkDeleting = false;
                this.showBulkDeleteDialog = false;
                this.bulkDeletePreview = null;
                this.bulkSelection = clearSelection();
                this.toastr.success(`${result?.deleted_entries ?? 0} hotlist entr${(result?.deleted_entries ?? 0) === 1 ? 'y' : 'ies'} removed.`, 'Success');
                this.fetchData(this.currentPage, this.recordsPerPage);
            },
            error: (err) => {
                this.bulkDeleting = false;
                this.toastr.error(err?.error?.detail || 'Bulk delete failed.', 'Error');
            },
        });
    }

  fetchData(page: number, pageSize: number){
      const ordering = this.sortColumn
          ? encodeSortColumnParam({
              sortColumn: this.sortColumn,
              sortDirection: this.sortDirection,
          })
          : null;
      this.apiService.getHotList(page, pageSize, this.searchText, ordering).subscribe({
      next: (data: any) => {
      this.hotlistedVehicles = data['results'];
      this.totalRecords = data['count'];
      this.nextPage = data['next']
      this.previousPage = data['previous']
    }
  });
  }

    sortData(column: string) {
        const next = toggleColumnSort(
            {sortColumn: this.sortColumn, sortDirection: this.sortDirection},
            column,
        );
        this.sortColumn = next.sortColumn;
        this.sortDirection = next.sortDirection;
        this.currentPage = 1;
        this.fetchData(this.currentPage, this.recordsPerPage);
    }
 
  get totalPages(): number {
    let totalPage =  Math.ceil(this.totalRecords / this.recordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  next() {
    if (this.nextPage){
      this.currentPage++;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }

  previous() {
    if (this.previousPage){
      this.currentPage--;
      this.fetchData(this.currentPage, this.recordsPerPage)
      }
  }

  selectPageSize(){
    if(this.recordsPerPage){
      // debugger;
      this.currentPage = 1;
      this.fetchData(this.currentPage, this.recordsPerPage)
    }
  }

    onPageChange(page: number): void {
        this.currentPage = page;
        this.fetchData(this.currentPage, this.recordsPerPage);
    }

    onPageSizeChange(pageSize: number): void {
        this.recordsPerPage = pageSize;
        this.currentPage = 1;
        this.fetchData(this.currentPage, this.recordsPerPage);
    }
  openConfirmationDialog(index: number) {
    this.showConfirmationDialog = true;
    this.pId = index;
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  removeFromHotlist() {
    this.apiService.removeHotlist(this.pId).subscribe({
      next: (response:any) => {
          this.toastr.success('Hotlisted Vehicle removed successfully.', 'Success');
        this.closeConfirmationDialog();
        // window.location.reload();
        window.location.href = '/view-hotlist'
      },
      error: (err) => {
        if (err['error']['detail']) {
            this.toastr.error(err['error']['detail'], 'Error');
          
        } else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error("Something went wrong!", 'Error');
        }
        this.closeConfirmationDialog();
      }
    })
  }

  vehicleSearch(){
  }

  exportToExcel() {
    this.apiService.exportHotlisted(this.currentPage, this.recordsPerPage, this.searchText).subscribe({
          next: (response: any) => {
            const fileName = getFileNameFromResponse(response);
              if (response.body) {
                  saveAs(response.body, fileName);
              }
           
          },
          error: (err) => {
            this.toastr.error(`${err}`, 'Error')
          }
        })
  }
  
  addHotList(){
    this.router.navigate(['/add-hotlist'])

  }


   openReason(reason: string) {
    this.reason = reason;
    this.showReason = true;
  }

  closeReason() {
    this.showReason = false;
  }
  
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const modalElement = document.querySelector('.modal-content');
    if (modalElement && !modalElement.contains(target)) {
      this.showReason = false;
    }
  }

  onResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
  this.currentPage = 1;
  this.recordsPerPage = 10;
  this.previousPage = event.previousPage;
  this.nextPage = event.nextPage;
  this.searchText = event.searchText;
  this.hotlistedVehicles = event.results;
  this.totalRecords = event.totalRecords;
      this.bulkSelection = clearSelection();
}

    downloadTemplate() {
        this.apiService.downloadImportTemplate('hotlist').subscribe({
            next: (response) => {
                const fileName = getFileNameFromResponse(response);
                if (response.body) {
                    saveAs(response.body, fileName);
                }
            },
            error: (err) => handleBulkImportFallbackError(err, this.toastr),
        });
    }

    openBulkUploadDialog() {
        this.bulkUpload.open();
    }

    closeBulkUploadDialog() {
        this.bulkUpload.close();
    }

    onBulkFileSelected(file: File) {
        this.bulkUpload.selectFile(file);
    }

    submitBulkUpload(file?: File) {
        this.bulkUpload.submit(file, () => {
            this.fetchData(this.currentPage, this.recordsPerPage);
        });
    }
}
